module.exports = __webpack_public_path__ + "img/font-italic.cc6ed263.svg";